import { getUserFromStorage } from "@/utils/user-store.util";

export function guardUser(to: any, from: any, next: any, role: string[]) {
  if (role.includes(getUserFromStorage()?.role)) {
    next();
  } else {
    next("/sign-in");
  }
}
